<li class="nav-item mr-2">
  <button *ngIf="enableDeleteButton" (click)="deleteTurn()" class="nav-link btn btn-danger"><i class="fa fa-times" aria-hidden="true"></i> {{ "delete" | language }}</button>
</li>
